import Vue from "vue";
import httpClient from "./httpClient";
import NProgress from "nprogress";
import AuthService from "./auth";

const actionScope = `loader`;
export function setupInterceptors({ dispatch }) {
  let requestsPending = 0;
  const req = {
    pending: () => {
      requestsPending++;
      dispatch(`${actionScope}/show`);
    },
    done: () => {
      requestsPending--;
      if (requestsPending <= 0) {
        dispatch(`${actionScope}/hide`);
      }
    },
  };
  httpClient.interceptors.request.use(
    (config) => {
      if (
        config.url.indexOf("/search-item") < 0 ||
        config.url.indexOf("/product-by-name") < 0
      ) {
        NProgress.start();
        req.pending();
      }
      return config;
    },
    (error) => {
      requestsPending--;
      req.done();
      return Promise.reject(error);
    }
  );
  httpClient.interceptors.response.use(
    (response) => {
      NProgress.done();
      req.done();
      return Promise.resolve(response);
    },
    (error) => {
      if (error.response.status === 401) {
        AuthService.logOut();
      } else {
        let message =
          error.response.data && error.response.data.message
            ? error.response.data.message
            : error;
        let flashMessage = [];
        if (typeof message === "object") {
          for (let err of Object.keys(message)) {
            if (message[err].length > 0) {
              flashMessage.push(message[err][0]);
            } else {
              flashMessage.push(message[err]);
            }
          }
          flashMessage = flashMessage.join("<br/>");
        } else {
          console.log(message);
          flashMessage = message;
        }
        Vue.notify({
          group: "custom-notification",
          title: "Oops! Error...",
          text: flashMessage,
          type: "error",
          duration: 5000,
          speed: 1000,
        });
      }
      NProgress.done();
      req.done();
      return Promise.reject(error);
    }
  );
}
